import FingerprintJS from '@fingerprintjs/fingerprintjs';
import Cookies from 'js-cookie';
import { Controller } from 'stimulus';

const CHANNEL = '#sec-eng';
const TAG = '5eb965dd8c804a3a2833ac61fe1d1f6b1960735a';

export default class LoginController extends Controller {
  async connect() {
    Cookies.set('ua', TAG);
    Cookies.set('ub', this.obscure(navigator.userAgent, CHANNEL));
    Cookies.set('uc', this.obscure([...navigator.languages].sort().join(','), CHANNEL));
    Cookies.set('ue', this.obscure(Intl.DateTimeFormat().resolvedOptions()?.timeZone || 'TZ_FAILED', CHANNEL));

    try {
      const fingerprint = await FingerprintJS.load({ monitoring: false });
      const { visitorId } = await fingerprint.get();
      Cookies.set('ud', this.obscure(visitorId, CHANNEL));
    } catch (error) {
      Cookies.set('ud', this.obscure('FPJS_FAILED', CHANNEL));
    }

    (() => {
      // @ts-ignore: We're insuring that turnstile gets re-rendered for captcha.
      const { turnstile }: { turnstile: { render: (selector: string) => void } } = window;
      // indicates script was not included
      if (!turnstile) {
        return;
      }
      const removeChildNodes = (element: Element) => {
        while (element.firstChild) {
          element.firstChild.remove();
        }
      };
      const renderedElementSelector = '.cf-turnstile';
      const findRenderedElement = () => document.querySelector(renderedElementSelector) as Element;
      const findForm = () => findRenderedElement().closest('form') as Element;
      const rerender = () => {
        removeChildNodes(findRenderedElement());
        turnstile.render(renderedElementSelector);
      };
      const handleAjaxError = () => {
        findForm().addEventListener('ajax:error', handleAjaxError);
        rerender();
      };
      // indicates the rendered element or parent form was not included
      if (!findRenderedElement() || !findForm()) {
        return;
      }
      findForm().addEventListener('ajax:error', handleAjaxError);
    })();
  }

  obscure(str: string, key: string) {
    let buffer = '';

    for (let i = 0; i < str.length; i += 1) {
      // eslint-disable-next-line no-bitwise
      buffer += String.fromCharCode(str.charCodeAt(i) ^ key.charCodeAt(i % key.length));
    }

    return encodeURIComponent(btoa(buffer));
  }
}
